/** Central TanStack Query keys (FRONTEND_PLAN §7.3). Mutations invalidate by prefix. */
export const keys = {
  customers: {
    list: (filters: object) => ['customers', 'list', filters] as const,
    detail: (id: string) => ['customers', 'detail', id] as const,
    preferences: (id: string) => ['customers', 'detail', id, 'preferences'] as const,
  },
  appointments: {
    list: (filters: object) => ['appointments', 'list', filters] as const,
    detail: (id: string) => ['appointments', 'detail', id] as const,
    events: (id: string) => ['appointments', 'detail', id, 'events'] as const,
  },
  availability: (query: object) => ['availability', query] as const,
  waitlist: {
    list: (filters: object) => ['waitlist', 'list', filters] as const,
  },
  resellers: {
    all: ['resellers'] as const,
    detail: (id: string) => ['resellers', 'detail', id] as const,
    roster: (id: string) => ['resellers', 'detail', id, 'roster'] as const,
  },
  platformOrganizations: (deleted: string) => ['organizations', 'all', deleted] as const,
  brandingAdmin: ['branding', 'admin'] as const,
  integrations: ['integrations'] as const,
  billing: {
    subscription: ['billing', 'subscription'] as const,
    usage: ['billing', 'usage'] as const,
  },
  publicPlans: ['public', 'plans'] as const,
  platformBilling: ['platform', 'billing-overview'] as const,
  auditLog: (filters: object) => ['audit-log', filters] as const,
  reports: (name: string, query: object) => ['reports', name, query] as const,
  workflowRules: {
    all: ['workflow-rules'] as const,
    list: (filters: object) => ['workflow-rules', 'list', filters] as const,
    ruleTypes: ['workflow-rules', 'rule-types'] as const,
  },
  templates: {
    all: ['message-templates'] as const,
    list: (filters: object) => ['message-templates', 'list', filters] as const,
    detail: (id: string) => ['message-templates', 'detail', id] as const,
    eventTypes: ['message-templates', 'event-types'] as const,
  },
  messages: (filters: object) => ['messages', filters] as const,
  conversations: {
    all: ['conversations'] as const,
    list: (filters: object) => ['conversations', 'list', filters] as const,
    detail: (id: string) => ['conversations', 'detail', id] as const,
  },
  recovery: {
    all: ['recovery'] as const,
    list: (filters: object) => ['recovery', 'list', filters] as const,
    detail: (id: string) => ['recovery', 'detail', id] as const,
    candidates: (id: string) => ['recovery', 'detail', id, 'candidates'] as const,
  },
  users: (filters: object) => ['users', filters] as const,
  location: (id: string) => ['locations', 'detail', id] as const,
  services: (filters: object) => ['services', filters] as const,
  resources: (filters: object) => ['resources', filters] as const,
  providers: {
    list: (filters: object) => ['providers', 'list', filters] as const,
    detail: (id: string) => ['providers', 'detail', id] as const,
    schedules: (id: string) => ['providers', 'detail', id, 'schedules'] as const,
    timeOff: (id: string) => ['providers', 'detail', id, 'time-off'] as const,
  },
  capabilities: ['capabilities'] as const,
  organization: (id: string) => ['organizations', id] as const,
  locations: (active: string) => ['locations', { active }] as const,
  notifications: {
    all: ['notifications'] as const,
    list: (filters: object) => ['notifications', 'list', filters] as const,
    unread: ['notifications', 'unread-count'] as const,
  },
}
